/*
 * Copyright (c) 2023.
 * Kevin <tranthaidnvn@gmail.com>
 */
import { config } from "core/config/app"

export const API_CLIENT_SETTING = `${config.apiPrefix}/${config.apiVersion}/commons/app-setting`;


